import { apiRequest } from '../http.js'

export const contentVaultApi = {
getAll: async (filters = {}, options = {}) => {
      const qs = new URLSearchParams()
      const add = (k, v) => {
        if (v == null) return
        const text = String(v).trim()
        if (!text) return
        qs.set(k, text)
      }
      add('page', filters.page)
      add('pageSize', filters.pageSize)
      add('status', filters.status)
      add('archiveState', filters.archiveState)
      add('campaignId', filters.campaignId)
      add('from', filters.from)
      add('to', filters.to)
      add('q', filters.q)
      const suffix = qs.toString() ? `?${qs.toString()}` : ''
      return apiRequest(`/content-vault${suffix}`, options)
    },
}
